

































import Vue from 'vue';
import Stats from './components/Stats.vue';

export default Vue.extend({
  name: 'App',
  components: {
    Stats,
  },
});
